module.exports = __webpack_public_path__ + "img/whatsapp-icon.170b1480.svg";